import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBanners, createBanner } from "../store/actions/banner";
import BannerCard from "../component/BannerCard";
import "./Banners.scss";

// Upload icon component
const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
    />
  </svg>
);

const Banners = () => {
  const dispatch = useDispatch();
  const { banners, error } = useSelector((state) => state.bannerReducer);
  const fileInputRef = useRef(null);

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(createBanner(file));
      event.target.value = null; // Reset file input
    }
  };

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <div className="banners-container">
      <div className="banner-header">
        <h1>Banner Management</h1>
        <div className="upload-section">
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileUpload}
            accept="image/*"
            style={{ display: "none" }}
          />
          <button
            className="upload-button"
            onClick={() => fileInputRef.current.click()}
          >
            <UploadIcon />
            Upload New Banner
          </button>
        </div>
      </div>
      <div className="banners-grid">
        {!banners ? (
          <div>Loading...</div>
        ) : Array.isArray(banners) ? (
          banners.map((banner) => (
            <BannerCard key={banner.id} banner={banner} />
          ))
        ) : (
          <div>No banners available</div>
        )}
      </div>
    </div>
  );
};

export default Banners;
